import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import CategoryFile from '../entities/categoryfile';
import CategoryFileLine from '../entities/categoryfileline';
import Util from '@/lib/util';
import appconst from './../../lib/appconst';

interface CategoryFileState extends ListState<CategoryFileLine> {
    itemsImported: Array<CategoryFileLine>,
    countItems : number,
    countImportedItems: number
}
class CategoryFileModule extends ListModule<CategoryFileState, any, CategoryFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<CategoryFileLine>(),
        loading: false,
        itemsImported: new Array<CategoryFileLine>(),
        countItems:0,
        countImportedItems:0
    }
    actions = {
        async getAll(context: ActionContext<CategoryFileState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/CategoryFileLine/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<CategoryFileLine>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async uploadImportCategoryFile(context: ActionContext<CategoryFileState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/CategoryFile/ImportCategories', data);
            return reponse.data.result
        },

        async get(context: ActionContext<CategoryFileState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/CategoryFile/Get?Id=' + payload.id);
            return reponse.data.result as CategoryFile;
        },
        async export(context:ActionContext<CategoryFileState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportCategories/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: CategoryFileState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: CategoryFileState, pagesize: number) {
            state.pageSize = pagesize;
        },
        processNotifier(state: CategoryFileState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    let categoryLine = payload.data.data as CategoryFileLine;
                    state.itemsImported.unshift(categoryLine);
                }
                if (payload.data.countItems != undefined && payload.data.countItems != null ) {
                    state.countItems = payload.data.countItems as number;
                }
                if (payload.data.countImportedItems != undefined && payload.data.countImportedItems != null) {
                    state.countImportedItems = payload.data.countImportedItems as number;
                }
            }
        },
        resetList(state: CategoryFileState) {
            state.itemsImported = new Array<CategoryFileLine>();
        } ,
        pageChangeItemsImported(state: CategoryFileState) {
            state.list = Util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const categoryFileModule = new CategoryFileModule();
export default categoryFileModule;